import {useAuthState} from "../../../context/AuthContext";
import {AccountsListService} from "../../ListOfAccounts/AccountsListService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../../context/SnackBarContext";
import React, {useEffect, useState} from "react";
import {
    DialogSize,
    RaikoButtonPrimary, RaikoCustomTooltip, RaikoDatePicker,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoNumberInputOutlined
} from "@moeindal/base-raiko-panel-components";
import CustomTable from "../../customTable/CustomTable";
import {Box, TextField} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import {css} from "@emotion/css";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../../utils/numberConvertor";
import DefaultDialogPage from "../../defaultDialogPage/DefaultDialogPage";
import moment from "jalali-moment";
import {preparePositiveNegativeNumberCell, prepareStatusCell} from "../../../utils/PrepareTableCellStyle";
import {addNewRowToTable} from "../../../utils/TableProvider";
import {convertUniversalDateToPersianDate} from "../../../utils/TimeConvertor";
import TransactionReceipt from "../../TransactionsList/TransactionReceipt";

export default function MonthlyDeposits({id}) {

    let page = 0
    const size = 15

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const [tableDataList, setTableDataList] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        getDataFromServer();
    }, []);

    function changePage(event, value) {
        page = value - 1
        getDataFromServer()
    }

    function prepareTableRow(id, number, amount, kind, depositedAt, createdAt, depositedByManager, depositedByMember, currentBalance, hasBeenDelayed, enabled, cleared, receiptUrl) {
        return {
            id: id,
            number: number,
            depositedAt: depositedAt ? moment(depositedAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-",
            hasBeenDelayed: hasBeenDelayed ? <span className="bg_deActive_state">دارد</span> :
                <span className="bg_active_state">ندارد</span>,
            kind: kind === "MANAGER_DEPOSIT" ? "ادمین" : "کاربر",
            depositedBy:
                depositedByManager && depositedByManager !== "" ? depositedByManager :
                    depositedByMember && depositedByMember !== "" ? depositedByMember : "-",
            amount: preparePositiveNegativeNumberCell(amount),
            status: prepareStatusCell(enabled),
            access: <RaikoCustomTooltip title={"رسید تراکنش"}>
                <div
                    className={`
                    ${css`width: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;`} ic-receipt`}

                    onClick={e => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleOpenReceiptDialog()
                        setReceiptItemInfo({id, receiptUrl})
                    }}
                />
            </RaikoCustomTooltip>
        }
    }

    const [receiptDialogState, setReceiptDialogState] = useState(false)
    const [receiptItemInfo, setReceiptItemInfo] = useState({});

    function handleOpenReceiptDialog() {
        setReceiptDialogState(true)
    }

    function handleCloseReceiptDialog() {
        setReceiptDialogState(false)
        setReceiptItemInfo({})
    }

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getMonthlyDepositOfAccount(fundID, id, page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setTableDataList([])
                response.data.map((item, index) => {
                    setTableDataList(prev => [
                        ...prev,
                        prepareTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.amount,
                            item.kind,
                            item.depositedAt,
                            item.createdAt,
                            item.depositedByManager,
                            item.depositedByMember,
                            item.currentBalance,
                            item.hasBeenDelayed,
                            item.enabled,
                            item.cleared,
                            item.receiptUrl,
                        )
                    ])
                })
            }).catch(reason => {
            showServerError(reason);

        }).finally(_ => {
            loading(setLoadingStateDispatch(false))
        })
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [amount, setAmount] = useState("")
    const [date, setDate] = useState("");

    function openAddNewTransactionDialog() {
        setOpenDialog(true)
    }

    function closeAddNewTransactionDialog() {
        setSelectedMonthItemId(-1)
        setAmount("")
        setDate("")
        setOpenDialog(false)
    }

    function handleAddNewTransaction() {
        if (checkFields()) {
            loading(setLoadingStateDispatch(true))
            service.addNewMonthlyDeposit(
                fundID,
                id,
                amount,
                date
            ).then(item => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تراکنش جدید با موفقیت افزوده شد."))
                const newItems = addNewRowToTable(
                    prepareTableRow(
                        item.id,
                        1,
                        item.amount,
                        item.kind,
                        item.depositedAt,
                        item.createdAt,
                        item.depositedByManager,
                        item.depositedByMember,
                        item.currentBalance,
                        item.hasBeenDelayed,
                        item.enabled,
                        item.cleared,
                        item.receiptUrl,
                    ), tableDataList
                )

                setTableDataList(newItems)

                setAmount("")
                setDate("")
                closeAddNewTransactionDialog()

            }).catch(reason => {
                showServerError(reason);

            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })
        }
    }

    function checkFields() {
        let state = false;
        let message = ""

        if (!amount || amount.length === 0)
            message = "لطفا مبلغ مورد نظر را وارد نمایید."
        else if (!date || date.length !== 10)
            message = "لطفا تاریخ پرداخت را انتخاب نمایید."
        else
            state = true

        if (message)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))


        return state
    }

    const [selectedMonthItemId, setSelectedMonthItemId] = useState(-1)

    function showServerError(reason) {
        if (reason.response && reason.response.data.message)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, reason.response.data.message))
        else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطایی رخ داده، لطفا مجددا تلاش نمایید."))
    }

    useEffect(() => {
        if (selectedMonthItemId && selectedMonthItemId > 0) {
            service.getMonthlyDepositOfAccountDetail(fundID, selectedMonthItemId)
                .then(response => {
                    setAmount(response.amount)
                    setDate(convertUniversalDateToPersianDate(response.depositedAt))
                    openAddNewTransactionDialog()
                }).catch(reason => {
                showServerError(reason);
            }).finally(_ => {

            })
        }
    }, [selectedMonthItemId]);

    function handleUpdateTransaction() {
        if (date.length === 10) {
            loading(setLoadingStateDispatch(true))
            service.updateNewMonthlyDeposit(fundID, selectedMonthItemId, amount, date)
                .then(response => {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
                    closeAddNewTransactionDialog()
                    getDataFromServer()
                }).catch(reason => {
                showServerError(reason);
            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })
        } else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا تاریخ را به درستی وارد نمایید"))
    }

    return (
        <>
            <DefaultDialogPage
                open={receiptDialogState}
                onClose={handleCloseReceiptDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"رسید تراکنش"}
            >
                <TransactionReceipt
                    info={receiptItemInfo}
                    handleUpdateTable={_ => {
                        getDataFromServer()
                    }}/>
            </DefaultDialogPage>
            <DefaultDialogPage
                onClose={closeAddNewTransactionDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={selectedMonthItemId > 0 ? "ویرایش تراکنش" : "تراکنش ماهیانه جدید"}
            >
                <RaikoGridOneColumn
                    className={css`
                      padding: 0 1rem 1rem 1rem;
                      z-index: 1000`}
                >
                    <TextField
                        dir="ltr"
                        className='w-100'
                        variant="outlined"
                        value={convertCurrencyFormatPositiveNegative(amount)}
                        onChange={e => {
                            const amount = e.target.value.replaceAll(",", "")
                            e.target.value = amount === "" ? "" : convertCurrencyFormatPositiveNegative(amount)
                            setAmount(amount)
                        }}
                        label="xمبلغ(ریال)"/>

                    <TextField
                        value={convertToBirthDate(date)}
                        onChange={e => {
                            setDate(convertToBirthDate(e.target.value))
                        }}
                        className={'w-100'}
                        variant={"outlined"}
                        label={"تاریخ پرداخت"}
                    />

                    <div
                        className={
                            css`
                              width: 100%;
                              display: flex;
                              justify-content: end;
                            `}
                    >
                        <RaikoButtonPrimary
                            label={selectedMonthItemId < 0 ? "ثبت تراکنش" : "بروزرسانی"}
                            onClick={_ => {
                                if (selectedMonthItemId > 0) {
                                    handleUpdateTransaction()
                                } else
                                    handleAddNewTransaction()
                            }}
                        />
                    </div>

                </RaikoGridOneColumn>
            </DefaultDialogPage>


            <RaikoGridOneColumn className={css`padding-top: 1rem`}>
                <div
                    className={css`
                      width: 100%;
                      display: flex;
                      justify-content: end;`}
                >
                    <RaikoButtonPrimary
                        label={"تراکنش جدید"}
                        onClick={openAddNewTransactionDialog}
                    />
                </div>
                <CustomTable
                    header={columns}
                    data={tableDataList}
                    rowClicked={id => setSelectedMonthItemId(id)}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={changePage}
                        showFirstButton showLastButton/>
                </Box>
            </RaikoGridOneColumn>
        </>
    )
}

const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'depositedAt',
        label: 'تاریخ پرداخت',
        align: 'right',
    },
    {
        id: 'kind',
        label: 'نوع واریز',
        align: 'right',
    },
    {
        id: 'depositedBy',
        label: 'واریز کننده',
        align: 'right',
    },
    {
        id: 'hasBeenDelayed',
        label: 'تاخیر',
        align: 'right',
    },
    {
        id: 'status',
        label: 'وضعیت',
        align: 'right',
    },
    {
        id: 'access',
        label: 'دسترسی',
        align: 'right',
    },
];
